import { render } from "./calndarVc.vue?vue&type=template&id=1785d954"
import script from "./calndarVc.vue?vue&type=script&lang=js"
export * from "./calndarVc.vue?vue&type=script&lang=js"

import "./calndarVc.vue?vue&type=style&index=0&id=1785d954&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__